(() => {
  try {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    const root = document.documentElement;
    root.classList.add('motion-pending');
    window.__prospectMotionSafetyTimer = window.setTimeout(() => {
      root.classList.remove('motion-pending');
      root.dataset.motionExpired = 'true';
    }, 2000);
  } catch {
    // Content remains visible when motion capability detection is unavailable.
  }
})();
